import { getTokenSync } from './authStorage';
import { downloadBlob, parseBlobError } from './blobDownload';

export async function fetchAuthenticatedBlob(url) {
  const token = getTokenSync();
  const res = await fetch(url, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  if (!res.ok) {
    throw new Error('Download failed');
  }
  const blob = await res.blob();
  const msg = await parseBlobError(blob);
  if (msg) {
    throw new Error(msg);
  }
  if (!(blob instanceof Blob) || blob.size === 0) {
    throw new Error('File is empty or unavailable');
  }
  return blob;
}

export async function downloadAuthenticatedUrl(url, filename) {
  const blob = await fetchAuthenticatedBlob(url);
  await downloadBlob(blob, filename || 'download');
}
